import axios from "axios";
import { getLoggedinUser, removeUserData, StorageManager } from "./StorageManager";
import { toast } from "react-toastify";

const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});
/*
function navigateTo(path, rep) {
  const navigate = useNavigate();
  navigate(path, { replace: rep });
}
*/
// Set the AUTH token for any request
client.interceptors.request.use((config) => {
  const userManager = new StorageManager("authUser");
  const auth_user = userManager.get();
  const newConfig = config;

  try {
    if (auth_user !== null) {
      newConfig.headers.Authorization = auth_user.user_token;
    }
  } catch (error) {
    console.log("authUser", error);
  }
  return newConfig;
});

/* eslint-disable */
client.interceptors.response.use(
  (response) => {
    switch (response.status) {
      case 200:
        return response.data;
      case 401:
        removeUserData();
        navigateTo("/", true);
      case 403:
        removeUserData();
        navigateTo("/", true);
      case 404:
        navigateTo("/notFound", false);
      case 500:
        console.log("500", response);
        toast.dismiss();

        toast.error(response, {
          position: "top-center",
          autoClose: 3000,
        });
        return response.data;
      case 502:
        navigateTo("/notFound", false);
        return JSON.parse("[{}]");
      default:
        return response.data;
    }
  },
  (error) => {
    console.log("error", error);
    toast.dismiss();

    toast.error(error, {
      position: "top-center",
      autoClose: 3000,
    });
    if (error.response?.status === 401) {
      const auth_user = getLoggedinUser();
      
      // Check if user is an expired trial user
      if (auth_user?.user_freeType === "trial") {
        const trialEndDate = auth_user?.user_billingCycleEnd 
          ? new Date(auth_user.user_billingCycleEnd) 
          : null;
        const isTrialExpired = trialEndDate && trialEndDate < new Date();
        
        if (isTrialExpired) {
          // Allow expired trial users to access billing, subscribe, and subscription pages
          const currentPath = window.location.pathname;
          const allowedPages = ["/billing", "/subscribe", "/subscription", "/free", "/register", "/monthly"];
          const isOnAllowedPage = allowedPages.some(page => currentPath === page || currentPath.startsWith(page + "/") || currentPath.startsWith(page + "?"));
          
          if (!isOnAllowedPage) {
            // Redirect to billing page for expired trial users (only if not on checkout pages)
            document.location.href = "/billing";
          }
          // Don't proceed with further redirects if trial is expired
          return error;
        }
      }
      
      if (!auth_user?.user_token) {
        removeUserData();
      }
      // window.history.push("/");
      const redirectUrl = window.location.pathname + window.location.search;
      //  console.log("postLoginRedirect", redirectUrl);
      localStorage.setItem("postLoginRedirect", redirectUrl);

      document.location.href = "/login";
    }
    return error;
    //if (error.response.status === 400) return error.response.data;
  }
);

export default client;
